// Module
var code = `<!-- Include conflict modal -->
<asset-upload-conflict-modal conflicts="\$ctrl.conflicts" show-conflict-modal="\$ctrl.showConflictModal"
        confirm-replace="\$ctrl.confirmReplace()" cancel-upload="\$ctrl.cancelUpload()"
        get-orientation-text="\$ctrl.getOrientationText(orientation)">
</asset-upload-conflict-modal>
<!-- Drop Zone -->
<div
        ngf-drop
        ngf-change="\$ctrl.fileDropped(\$files, \$file, \$newFiles, \$duplicateFiles, \$invalidFiles, \$event)"
        ngf-select="\$ctrl.fileDropped(\$files, \$file, \$newFiles, \$duplicateFiles, \$invalidFiles, \$event)"
        ngf-multiple="true"
        ngf-drag-over-class="'asset-upload-drag-over'"
        ngf-hide-on-drop-not-available="true"
        ngf-pattern="!.mov,image/*,video/*"
        ngf-max-size="\$ctrl.maxFileSize"
        style="height: 100%; width: 100%;"
>
        <div class="asset-upload-title">Click or drop to upload</div>
        <div
                class="asset-upload-files-remaining"
                ng-if="\$ctrl.stats.filesRemaining"
        >
                {{\$ctrl.stats.filesRemaining}} files remaining
        </div>
        <div
                class="asset-upload-bytes-remaining"
                ng-if="\$ctrl.stats.bytesRemaining"
        >
                {{\$ctrl.stats.bytesRemaining | bytes}} remaining
        </div>
</div>
`;
// Exports
export default code;